import ImageItem from 'rlink-media/ImageItem';

export default class StudioSlideshowImage extends ImageItem {
  get adminLabel () {
    return this.title.length > 0 ? this.title : '<untitled studio slide>';
  }

  get mainImageFormats () {
    return {
      src: this.imagePath,
      formats: [
        {contentType: 'image/webp', fileExt: 'webp'},
        {contentType: 'image/jpeg', fileExt: 'jpg'},
      ],
      widths: [
        1920, 1440, 1024, 750,
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/content-types/StudioSlideshowImage.js